import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import ProductInfoContainer from '../../../components/common/ProductInfoContainer';
import CompareTrialPlanTable from '../../../components/feature-table/trial-upgrade/CompareTrialPlanTable';
import { TRIAL_UPGRADE_PAGE } from '../../../constants/ErrorBoundaryNames';
import { SCREENS, UPGRADE_PAGES } from '../../../constants/tracking/Locations';
import { withErrorBoundary } from '../../ErrorBoundary';
import CompareTrialPlanTableLink from './CompareTrialPlanTableLink';
import TrialUpgradeDaysRemainingHeader from './TrialUpgradeDaysLeftHeader';
import TrialUpgradeFeaturePanels from './TrialUpgradeFeaturePanels';
import TrialUpgradeHeroBanner from './TrialUpgradeHeroBanner';
import TrialUpgradeNavBanner from './TrialUpgradeNavBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TrialUpgradePage = ({
  apiName
}) => {
  const queryParams = getQueryParams();
  const upgradeSource = typeof queryParams.upgradeSource !== 'string' ? '' : queryParams.upgradeSource;
  useEffect(() => {
    getUsageTracker().setProperties({
      screen: SCREENS.UPGRADE_PAGE,
      subscreen: UPGRADE_PAGES.TRIAL,
      upgradeSource
    });
    getUsageTracker().track('upgradesInteraction', {
      action: 'viewed trial upgrade page',
      apiName
    });
  }, [upgradeSource, apiName]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "TRIAL_UPGRADE_PAGE"
    }), /*#__PURE__*/_jsx(TrialUpgradeNavBanner, {
      apiName: apiName
    }), /*#__PURE__*/_jsx(TrialUpgradeHeroBanner, {
      apiName: apiName
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      className: "m-all-auto p-bottom-10",
      children: [/*#__PURE__*/_jsx(CompareTrialPlanTableLink, {}), /*#__PURE__*/_jsx(TrialUpgradeDaysRemainingHeader, {
        apiName: apiName
      }), /*#__PURE__*/_jsx(TrialUpgradeFeaturePanels, {
        apiName: apiName
      }), /*#__PURE__*/_jsx(CompareTrialPlanTable, {
        upgradePointApiName: apiName,
        purchaseMotions: [BUY_TOUCHLESS]
      })]
    })]
  });
};
export default withErrorBoundary(TrialUpgradePage, {
  boundaryName: TRIAL_UPGRADE_PAGE,
  redirectCallback: () => '/'
});